import { escapeRegExp, stripHtml } from 'helpers'
import { Helmet } from 'react-helmet'

export default ({ course, reviews }) => {
  const description = escapeRegExp(stripHtml(course.Description))
  return (
    course.IsFree
      ? (
        <Helmet>
          <script type='application/ld+json'>
            {`
          {
            "@context": "https://schema.org",
            "@type": "Product",
            "name": "${course.Title}",
            "description": "${description}",
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "${course.Rating || 5}",
              "reviewCount": "${course.ReviewersCount || 1}"
            },
            "offers": {
              "@type": "AggregateOffer",
              "offerCount": "10000",
              "lowPrice": "00.00",
              "highPrice": "00.00",
              "priceCurrency": "EUR"
            },
            "review": [
              ${reviews.length
                ? reviews.map(review => (`{
                    "@type": "Review",
                    "author": {
                      "@type": "Person",
                      "name": "${review.Author || 'Utilisateur'}"
                    },
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "${review.Rating || 5}",
                      "bestRating": "5"
                    }
                  }
                `))
                : `
                {
                  "@type": "Review",
                  "author": {
                    "@type": "Person",
                    "name": "Utilisateur"
                  },
                  "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": "5",
                    "bestRating": "5"
                  }
                }`}
            ]
          }
        `}
          </script>
        </Helmet>
        )
      : null
  )
}
